<template>
    <div>
      <div class="overlay"></div>
      <div class="loading-container">
        <div class="loader">Loading...</div>
      </div>
    </div>
  </template>
  <style type="text/css" scoped>
  .overlay {
    position: fixed;
    overflow: hidden;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.2);
    opacity: 1;
    z-index: 1040;
  }
  
  .loader,
  .loader:after {
    border-radius: 50%;
    width: 2.25rem;
    height: 2.25rem;
  }
  
  .loading-container {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 2.25rem;
    z-index: 1050;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #FFFFFF;
    border-radius: 4px;
    overflow: hidden;
  }
  
  .loader {
    font-size: 10px;
    text-indent: -9999em;
    background: url('data:image/svg+xml,%3Csvg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"%3E%3Cpath d="M30.728 5.27193L27.9 8.09993C25.6098 5.80953 22.5964 4.38405 19.373 4.06641C16.1496 3.74877 12.9159 4.55859 10.2227 6.35791C7.52948 8.15723 5.54348 10.8347 4.60308 13.9342C3.66268 17.0336 3.82604 20.3632 5.06536 23.3558C6.30468 26.3482 8.54324 28.8184 11.3997 30.3454C14.256 31.8724 17.5536 32.3618 20.7304 31.7302C23.9072 31.0984 26.7666 29.3848 28.8216 26.8812C30.8764 24.3776 31.9998 21.239 32 18H36C36 22.1644 34.556 26.1998 31.914 29.419C29.2722 32.638 25.5958 34.8416 21.5114 35.654C17.4272 36.4664 13.1874 35.8374 9.51474 33.8744C5.84208 31.9112 2.96374 28.7354 1.37012 24.888C-0.223495 21.0406 -0.433776 16.7596 0.775124 12.7745C1.984 8.78945 4.53726 5.34685 7.99984 3.03325C11.4624 0.719674 15.62 -0.321746 19.7644 0.0864741C23.9088 0.494674 27.7834 2.32725 30.728 5.27193Z" fill="url(%23paint0_linear_351_3371)"/%3E%3Cdefs%3E%3ClinearGradient id="paint0_linear_351_3371" x1="18" y1="-3.60001" x2="18" y2="39.6" gradientUnits="userSpaceOnUse"%3E%3Cstop stop-color="%235580A0"/%3E%3Cstop offset="0.979167" stop-color="%235580A0"/%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E');
    -webkit-animation: load8 1.1s infinite linear;
    animation: load8 1.1s infinite linear;
  }
  
  @-webkit-keyframes load8 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
  
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  
  @keyframes load8 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
  
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  </style>
  